import { ReduxAxiosError } from '@/store/reducers/api-requests/types';
import { ContactVm } from '@/types';

export type Contact = ContactVm & {
  readonly contactId: string;
  readonly eligibleEdit?: boolean;
};

export type Props = {
  isModalOpen: boolean;
  selectedAddress: ContactVm | null;
  shippingAddresses: ContactVm[];
  createAddressError: ReduxAxiosError;
  updateAddressError: ReduxAxiosError;
  deleteAddressError: ReduxAxiosError;
  initialModalView: AddressBookModalViews;
  loadingFetch: boolean;
  loadingCreate: boolean;
  loadingUpdate: boolean;
  loadingDelete: boolean;
  closeModal: () => void;
  selectAddress: (contact: ContactVm) => void;
  createShippingAddress: (contact: ContactVm) => void;
  updateShippingAddress: (contact: ContactVm) => void;
  deleteShippingAddress: (contactId: string) => void;
};

export enum AddressBookModalViews {
  AddressForm,
  AddressList,
  DeleteAddressConfirmation,
}

export type ContactAddress = {
  title: string;
  isDefault: boolean;
  isSavedAddress: boolean;
  contact: ContactVm;
};
